module.exports = __webpack_public_path__ + "img/help-circles.391b41fc.svg";